import { Tabs } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import Icon from 'shared/components/vxl/icon/Icon/Icon';
import BodyXSBoldText from 'shared/components/vxl/typography/primary/body/BodyXSBoldText';
import { isWeb } from 'shared/constants/platform';
import { usePressableAnalytics } from 'shared/hooks/analytics/usePressableAnalytics';
import HomeStrings from 'shared/localization/localizedStrings/HomeStrings';
import RewardsStrings from 'shared/localization/localizedStrings/RewardsStrings';
import theme from 'shared/styles/theme';

const TAB_BAR_ACTIVE_COLOR = theme.color.text.primary;
const TAB_BAR_INACTIVE_COLOR = theme.color.text.tertiary;

export default function TabBar() {
  const { t: translatedTextMoveMoney } = useTranslation('moveMoney', {
    keyPrefix: 'move',
  });
  const { t: translatedTextMyVaro } = useTranslation('myVaro');

  const logMyVaroTabClickedAnalytics = usePressableAnalytics({
    analyticsId: 'myVaroTabClicked',
  });

  const logRewardsTabClickedAnalytics = usePressableAnalytics({
    analyticsId: 'perkTabClicked',
  });

  return (
    <View style={styles.container}>
      <Tabs
        backBehavior="history"
        screenOptions={{
          tabBarActiveTintColor: TAB_BAR_ACTIVE_COLOR,
          tabBarInactiveTintColor: TAB_BAR_INACTIVE_COLOR,
          tabBarStyle: {
            marginBottom: isWeb ? theme.spacing.m : 0,
          },
        }}
      >
        <Tabs.Screen
          name="index"
          options={{
            title: HomeStrings.title,
            tabBarButtonTestID: 'tab-bar-home',
            headerShown: false,
            tabBarIcon: ({ focused }) => (
              <Icon
                iconKey="HOME"
                iconColor={
                  focused ? TAB_BAR_ACTIVE_COLOR : TAB_BAR_INACTIVE_COLOR
                }
                iconSize="MD"
              />
            ),
            tabBarLabel: ({ focused }) => (
              <BodyXSBoldText
                testID="tab-bar-label"
                style={{
                  color: focused
                    ? TAB_BAR_ACTIVE_COLOR
                    : TAB_BAR_INACTIVE_COLOR,
                  ...styles.tabItem,
                }}
              >
                {HomeStrings.title}
              </BodyXSBoldText>
            ),
            tabBarAccessibilityLabel: HomeStrings.title,
          }}
        />
        <Tabs.Screen
          name="move-money"
          options={{
            title: translatedTextMoveMoney('title'),
            tabBarButtonTestID: 'tab-bar-move-money',
            headerShown: false,
            tabBarIcon: ({ focused }) => (
              <Icon
                iconKey="MOVE_MONEY"
                iconColor={
                  focused ? TAB_BAR_ACTIVE_COLOR : TAB_BAR_INACTIVE_COLOR
                }
                iconSize="MD"
              />
            ),
            tabBarLabel: ({ focused }) => (
              <BodyXSBoldText
                testID="tab-bar-label"
                style={{
                  color: focused
                    ? TAB_BAR_ACTIVE_COLOR
                    : TAB_BAR_INACTIVE_COLOR,
                  ...styles.tabItem,
                }}
              >
                {translatedTextMoveMoney('title')}
              </BodyXSBoldText>
            ),
            tabBarAccessibilityLabel: translatedTextMoveMoney('title'),
          }}
        />
        <Tabs.Screen
          name="rewards"
          listeners={{
            tabPress: logRewardsTabClickedAnalytics,
          }}
          options={{
            title: RewardsStrings.title,
            tabBarButtonTestID: 'tab-bar-rewards',
            headerShown: false,
            tabBarIcon: ({ focused }) => (
              <Icon
                iconKey="PERKS"
                iconColor={
                  focused ? TAB_BAR_ACTIVE_COLOR : TAB_BAR_INACTIVE_COLOR
                }
                iconSize="MD"
              />
            ),
            tabBarLabel: ({ focused }) => (
              <BodyXSBoldText
                testID="tab-bar-label"
                style={{
                  color: focused
                    ? TAB_BAR_ACTIVE_COLOR
                    : TAB_BAR_INACTIVE_COLOR,
                  ...styles.tabItem,
                }}
              >
                {RewardsStrings.title}
              </BodyXSBoldText>
            ),
            tabBarAccessibilityLabel: RewardsStrings.title,
          }}
        />
        <Tabs.Screen
          name="myvaro"
          listeners={{
            tabPress: logMyVaroTabClickedAnalytics,
          }}
          options={{
            title: translatedTextMyVaro('title'),
            tabBarButtonTestID: 'tab-bar-my-varo',
            headerShown: false,
            tabBarIcon: ({ focused }) => (
              <Icon
                iconKey="PROFILE"
                iconColor={
                  focused ? TAB_BAR_ACTIVE_COLOR : TAB_BAR_INACTIVE_COLOR
                }
                iconSize="MD"
              />
            ),
            tabBarLabel: ({ focused }) => (
              <BodyXSBoldText
                testID="tab-bar-label"
                style={{
                  color: focused
                    ? TAB_BAR_ACTIVE_COLOR
                    : TAB_BAR_INACTIVE_COLOR,
                  ...styles.tabItem,
                }}
              >
                {translatedTextMyVaro('title')}
              </BodyXSBoldText>
            ),
            tabBarAccessibilityLabel: translatedTextMyVaro('title'),
          }}
        />
      </Tabs>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
  tabItem: {
    flexShrink: 0,
    textAlign: 'center',
    width: '100%',
  },
});
